import PropTypes from "prop-types";
import { Tooltip, Typography } from "@mui/material";

import "./overflowTooltip.scss";

export default function OverflowTooltip({ value }) {
  const displayValue = value ?? "-";

  return (
    <Tooltip title={String(displayValue)} arrow placement="top">
      <Typography component="span" className="overflow-tooltip-text">
        {displayValue}
      </Typography>
    </Tooltip>
  );
}

OverflowTooltip.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
